import BaseHeading from './BaseHeading'
import type { ReactNode } from 'react'

interface PropsType {
  children: ReactNode
}

const MiscHeading = (props: PropsType) => <BaseHeading $borderColor="#ccc">{props.children}</BaseHeading>

export default MiscHeading
